<template>
  <div class="w-100 my-5">
    <div class="box-white d-flex flex-column">
      <div class="row w-100 mt-5 vertical-center">
        <span class="col-sm-2 m-1 font-bold font-12 alpha-07">Collection</span>
        <input class="col-sm m-1 font-12" v-model="collection" />
      </div>
      <div class="row w-100 mt-5 vertical-center">
        <span class="col-sm-2 m-1 font-bold font-12 alpha-07">ID</span>
        <input class="col-sm m-1 font-12" v-model="id" />
      </div>
      <div class="my-5 d-flex justify-content-end">
        <v-btn class="mx-5 button-normal" small @click="updateDocumentTask" :disabled="(!collection || !id)">
          <span>Update Document</span>
        </v-btn>
        <v-btn class="mx-5 button-red" small @click="deleteDocumentTask" :disabled="(!collection || !id)">
          <span>Delete Document</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../main';
import { showLoading } from '../../../functions';

export default {
  name: 'EditDocument',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    }
  },
  data() {
    return {
      collection: '',
      id: ''
    }
  },
  mounted() {
    if (window.location.hostname !== 'localhost') {
      this.$router.push('/');
    }
  },
  methods: {
    updateDocumentTask() {
      if (!this.collection) {
        this.$toast.info('Please enter collection.');
        return;
      }
      if (!this.id) {
        this.$toast.info('Please enter ID.');
        return;
      }
      const params = {
        functionName: 'updateDocumentInfo',
        collection: this.collection,
        id: this.id,
        updateInfo: {
        }
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    },
    deleteDocumentTask() {
      if (!this.collection) {
        this.$toast.info('Please enter collection.');
        return;
      }
      if (!this.id) {
        this.$toast.info('Please enter ID.');
        return;
      }
      if (!confirm('Really?')) {
        return;
      }
      const params = {
        functionName: 'deleteDocumentInfo',
        collection: this.collection,
        id: this.id
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>